/* ═══════════════════════════════════════════════════════
   Topscent Buy Box v2.1
   - Event delegation (survives Customize re-renders)
   - shopify:section:load re-init
   - Scent-reactive gallery (row tap swaps images)
   - Mixed cart via /cart/add.js
   - Membership = single-select
   ═══════════════════════════════════════════════════════ */
(function () {
  'use strict';

  // Patch 14: these are FALLBACKS only. Live prices are read from Shopify
  // variant data (variant.price, selling_plan.price). Constants are used only
  // if variant data is missing for some reason.
  var UNIT_PRICE_FALLBACK = 1795;
  var MEMBERSHIP_PRICE_FALLBACK = 1495;

  function initSection(sectionEl) {
    if (!sectionEl) return;
    var sectionId = sectionEl.dataset.sectionId;
    if (!sectionId) return;

    var dataEl = document.getElementById('showcase-data-' + sectionId);
    if (!dataEl) return;
    var products;
    try { products = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!products.length) return;

    // ── State ──
    var quantities = {};
    var currentPackage = 'standard';
    var currentPurchaseType = 'onetime';
    var activeScent = null; // handle of scent whose gallery is showing

    products.forEach(function (p) { quantities[p.handle] = 0; });

    // ── DOM refs ──
    var rowsContainer = document.getElementById('showcase-v2-rows-' + sectionId);
    var totalEl = document.getElementById('showcase-v2-total-' + sectionId);
    var atcBtn = document.getElementById('showcase-atc-' + sectionId);
    var subTotalEl = document.getElementById('showcase-sub-total-' + sectionId);
    var onetimeTotalEl = document.getElementById('showcase-onetime-total-' + sectionId);
    var subPerBlockEl = document.getElementById('showcase-sub-perblock-' + sectionId);
    var onetimePerBlockEl = document.getElementById('showcase-onetime-perblock-' + sectionId);
    var cardsGroup = document.getElementById('showcase-cards-' + sectionId);
    var mainImg = document.getElementById('showcase-main-img-' + sectionId);
    var thumbsEl = document.getElementById('showcase-thumbs-' + sectionId);

    // ── Helpers ──
    function formatMoney(pence) {
      return '\u00a3' + (pence / 100).toFixed(2);
    }

    // Patch 14.2: swap the hero image. The server renders a responsive srcset on
    // the initial image; when JS swaps to a chosen scent we clear srcset/sizes so
    // the new single src wins (the swap sources are already square, matching the
    // reserved 1:1 box, so no layout shift).
    function setMainImage(src, alt) {
      if (!mainImg) return;
      mainImg.removeAttribute('srcset');
      mainImg.removeAttribute('sizes');
      mainImg.src = src;
      mainImg.alt = alt || '';
    }

    function getTotalQty() {
      var total = 0;
      for (var h in quantities) total += quantities[h];
      return total;
    }

    function getProductByHandle(handle) {
      for (var i = 0; i < products.length; i++) {
        if (products[i].handle === handle) return products[i];
      }
      return null;
    }

    function getActiveVariant(product) {
      if (!product || !product.variants) return null;
      if (currentPackage === 'gift') {
        for (var i = 0; i < product.variants.length; i++) {
          if (product.variants[i].title.toLowerCase().indexOf('gift') !== -1) return product.variants[i];
        }
      }
      for (var i = 0; i < product.variants.length; i++) {
        if (product.variants[i].title.toLowerCase().indexOf('gift') === -1) return product.variants[i];
      }
      return product.variants[0];
    }

    // Patch 14: live one-time unit price for the currently selected package.
    function getUnitPrice(product) {
      var v = getActiveVariant(product);
      if (v && typeof v.price === 'number') return v.price;
      return UNIT_PRICE_FALLBACK;
    }

    // Patch 14: live membership unit price from the active variant's selling plan.
    // Returns null when the active variant has NO selling plan (e.g. Gift Set with
    // no gift subscription), so callers can disable membership honestly.
    function getMembershipUnitPrice(product) {
      var v = getActiveVariant(product);
      if (v && v.selling_plans && v.selling_plans.length && typeof v.selling_plans[0].price === 'number') {
        return v.selling_plans[0].price;
      }
      return null;
    }

    // Patch 14 fix: representative unit price for the CURRENT package, independent
    // of quantity, for the per-block rate labels ("£17.95 a block"). Uses the first
    // product as the reference (all scents share the same price structure). Falls
    // back to the constant only if variant data is missing.
    function getPackageUnitPrice() {
      if (products.length) {
        var v = getActiveVariant(products[0]);
        if (v && typeof v.price === 'number') return v.price;
      }
      return UNIT_PRICE_FALLBACK;
    }

    // Membership unit price for the current package (null if the package has no
    // selling plan, e.g. Gift Set with no gift subscription).
    function getPackageMembershipUnitPrice() {
      if (products.length) {
        var m = getMembershipUnitPrice(products[0]);
        if (m !== null) return m;
        // If the reference product has a plan on Standard but not Gift, this returns
        // null only when the active (package) variant genuinely lacks a plan.
        return null;
      }
      return MEMBERSHIP_PRICE_FALLBACK;
    }

    // Patch 14: does the currently selected package support membership for every
    // selected scent? Gift Set membership is only allowed if a real gift selling
    // plan exists on the active variant.
    function membershipAvailableForCurrentPackage() {
      for (var i = 0; i < products.length; i++) {
        if (getMembershipUnitPrice(products[i]) === null) return false;
      }
      return true;
    }

    // ── Gallery swap ──
    var PACKAGE_VIDEOS = {
      gift: 'https://cdn.shopify.com/videos/c/o/v/af03e49ddc9b4d1281a624a321dfe875.mp4',
      standard: 'https://cdn.shopify.com/videos/c/o/v/616fa812d40c483bb23ba5a286089713.mp4'
    };
    var galleryContainer = mainImg ? mainImg.parentElement : null;
    var showingVideo = false;
    // Patch 13D: stable poster captured before any innerHTML swaps destroy mainImg.
    var initialPoster = (mainImg && mainImg.src) ? mainImg.src : '';

    // Patch 13D: only autoplay package video on a good connection with motion allowed.
    // Data saver on, reduced motion, or no matchMedia support -> poster only.
    function videoAllowed() {
      var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      if (conn && conn.saveData) return false;
      if (!window.matchMedia) return false;
      return window.matchMedia('(prefers-reduced-motion: no-preference)').matches;
    }

    function posterFor() {
      // Prefer the live gallery image, fall back to the poster captured at init.
      if (mainImg && mainImg.src) return mainImg.src;
      return initialPoster;
    }

    function setVideoGallery(url) {
      if (!galleryContainer) return;
      showingVideo = true;
      if (thumbsEl) thumbsEl.style.display = 'none';

      var poster = posterFor();

      // Poster-first: if the connection or motion preference is against us, show the poster only.
      if (!videoAllowed()) {
        galleryContainer.innerHTML = '<img class="ts-v2-gallery__poster" src="' + poster + '" alt="" loading="eager">';
        return;
      }

      var posterAttr = poster ? ' poster="' + poster + '"' : '';
      galleryContainer.innerHTML =
        '<video class="ts-v2-gallery__video" autoplay muted loop playsinline preload="none"' + posterAttr + '>' +
        '<source src="' + url + '" type="video/mp4">' +
        '</video>';

      var vid = galleryContainer.querySelector('video');
      if (vid) {
        // If the video fails to load or play, fall back to the poster silently.
        vid.addEventListener('error', function () {
          if (!showingVideo) return;
          galleryContainer.innerHTML = '<img class="ts-v2-gallery__poster" src="' + poster + '" alt="" loading="eager">';
        });
        var playAttempt = vid.play();
        if (playAttempt && typeof playAttempt.catch === 'function') {
          playAttempt.catch(function () {
            if (!showingVideo) return;
            galleryContainer.innerHTML = '<img class="ts-v2-gallery__poster" src="' + poster + '" alt="" loading="eager">';
          });
        }
      }
    }

    function restoreImageGallery() {
      if (!galleryContainer || !showingVideo) return;
      showingVideo = false;
      // Restore the img element
      galleryContainer.innerHTML = '<img id="showcase-main-img-' + sectionId + '" src="" alt="" width="900" height="900" loading="eager">';
      mainImg = document.getElementById('showcase-main-img-' + sectionId);
      if (thumbsEl) thumbsEl.style.display = '';
      // Re-render active scent gallery
      if (activeScent) {
        var oldScent = activeScent;
        activeScent = null; // force re-render
        setGallery(oldScent);
      }
    }

    function setGallery(handle) {
      if (handle === activeScent && !showingVideo) return;
      // Scent tap wins — restore from video if showing one
      if (showingVideo) {
        restoreImageGallery();
        // activeScent was cleared in restoreImageGallery, will re-render below
      }
      activeScent = handle;

      var product = getProductByHandle(handle);
      if (!product || !product.images || !product.images.length) return;

      // Set pastel wash
      sectionEl.setAttribute('data-active-scent', handle);

      // Main image
      if (mainImg) {
        setMainImage(product.images[0].src, product.images[0].alt);
      }

      // Thumbs
      if (thumbsEl) {
        thumbsEl.innerHTML = '';
        product.images.forEach(function (img, i) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'topscent-showcase__thumb' + (i === 0 ? ' active' : '');
          btn.setAttribute('aria-label', 'View image ' + (i + 1));
          var imgEl = document.createElement('img');
          imgEl.src = img.thumb;
          imgEl.alt = img.alt;
          imgEl.loading = 'lazy';
          btn.appendChild(imgEl);
          btn.addEventListener('click', function () {
            if (mainImg) {
              setMainImage(img.src, img.alt);
            }
            thumbsEl.querySelectorAll('.topscent-showcase__thumb').forEach(function (t) { t.classList.remove('active'); });
            btn.classList.add('active');
          });
          thumbsEl.appendChild(btn);
        });
      }

      // Highlight active row visually
      if (rowsContainer) {
        rowsContainer.querySelectorAll('.ts-v2-row').forEach(function (r) {
          r.classList.toggle('ts-v2-row--active', r.dataset.handle === handle);
        });
      }
    }

    // ── Update totals + CTA ──
    function updateAll() {
      var totalQty = getTotalQty();

      // Patch 14: totals summed from live variant prices per selected scent,
      // respecting the current package (Standard vs Gift Set). Supports mixed
      // quantities across scents.
      var totalOnetime = 0;
      var totalMembership = 0;
      var membershipPriceable = true;
      var lastUnitPrice = UNIT_PRICE_FALLBACK; // for the per-block line when one price dominates
      for (var pi = 0; pi < products.length; pi++) {
        var prod = products[pi];
        var qty = quantities[prod.handle] || 0;
        if (qty <= 0) continue;
        var unit = getUnitPrice(prod);
        lastUnitPrice = unit;
        totalOnetime += unit * qty;
        var mUnit = getMembershipUnitPrice(prod);
        if (mUnit === null) {
          membershipPriceable = false;
        } else {
          totalMembership += mUnit * qty;
        }
      }

      var giftMembershipBlocked = (currentPackage === 'gift') && !membershipAvailableForCurrentPackage();

      // Update row qty displays + selected state (Patch 13C)
      if (rowsContainer) {
        rowsContainer.querySelectorAll('.ts-v2-row').forEach(function (row) {
          var handle = row.dataset.handle;
          var qty = quantities[handle] || 0;
          var display = row.querySelector('[data-qty-display]');
          if (display) display.textContent = qty;
          var minusBtn = row.querySelector('[data-action="minus"]');
          if (minusBtn) minusBtn.disabled = qty === 0;
          row.classList.toggle('ts-v2-row--selected', qty > 0);
        });
      }

      // Pinned total + per-block/day line (now reflects the selected package price)
      if (totalEl) {
        var totalLine = 'Total: ' + totalQty + ' block' + (totalQty !== 1 ? 's' : '') + ' \u00b7 ' + formatMoney(totalOnetime);
        if (totalQty > 0) {
          totalLine += '<span class="ts-v2-total__perday">' + formatMoney(lastUnitPrice) + ' a block.</span>';
        }
        totalEl.innerHTML = totalLine;
      }

      // Card totals
      if (subTotalEl) {
        if (totalQty > 0 && membershipPriceable) {
          subTotalEl.textContent = formatMoney(totalMembership) + ' every 30 days';
        } else {
          subTotalEl.textContent = '';
        }
      }
      if (onetimeTotalEl) onetimeTotalEl.textContent = totalQty > 0 ? formatMoney(totalOnetime) : '';

      // Patch 14 fix: per-block sublabels track the SELECTED package price so they
      // never contradict the totals. One-Time: £17.95 (Standard) / £29.95 (Gift Set).
      // Membership: £14.95 (Standard); hidden when gift membership is unavailable.
      var pkgUnit = getPackageUnitPrice();
      if (onetimePerBlockEl) onetimePerBlockEl.textContent = formatMoney(pkgUnit) + ' a block';
      if (subPerBlockEl) {
        var mUnit = getPackageMembershipUnitPrice();
        subPerBlockEl.textContent = (mUnit === null) ? '' : (formatMoney(mUnit) + ' a block');
      }

      // Patch 14: reflect membership availability for the current package on the
      // Membership card. If Gift Set has no selling plan, disable membership and
      // explain, and fall back to one-time so no stale/subscribe state lingers.
      applyMembershipAvailability(giftMembershipBlocked);
      if (giftMembershipBlocked && currentPurchaseType === 'subscribe') {
        selectPurchaseType('onetime');
        return; // selectPurchaseType calls updateAll again
      }

      // CTA
      if (atcBtn) {
        if (totalQty === 0) {
          atcBtn.disabled = true;
          atcBtn.textContent = 'Add to cart \u00b7 \u00a30.00';
        } else {
          atcBtn.disabled = false;
          if (currentPurchaseType === 'subscribe' && membershipPriceable) {
            atcBtn.textContent = 'Start membership \u00b7 ' + formatMoney(totalMembership) + ' every 30 days';
          } else {
            atcBtn.textContent = 'Add to cart \u00b7 ' + formatMoney(totalOnetime);
          }
        }
      }
    }

    // Patch 14: disable/enable the Membership card based on gift availability.
    function applyMembershipAvailability(blocked) {
      if (!cardsGroup) return;
      var subCard = cardsGroup.querySelector('.topscent-showcase__card[data-purchase="subscribe"]');
      if (!subCard) return;
      var note = subCard.querySelector('.topscent-showcase__card-unavailable');
      if (blocked) {
        subCard.classList.add('topscent-showcase__card--disabled');
        subCard.setAttribute('aria-disabled', 'true');
        subCard.setAttribute('tabindex', '-1');
        if (!note) {
          note = document.createElement('p');
          note.className = 'topscent-showcase__card-unavailable';
          note.textContent = 'Membership is available on Standard only. Switch to Standard to subscribe.';
          var body = subCard.querySelector('.topscent-showcase__card-top');
          if (body && body.parentNode) body.parentNode.appendChild(note);
        }
      } else {
        subCard.classList.remove('topscent-showcase__card--disabled');
        subCard.removeAttribute('aria-disabled');
        subCard.setAttribute('tabindex', '0');
        if (note && note.parentNode) note.parentNode.removeChild(note);
      }
    }

    // ── EVENT DELEGATION on rows container ──
    if (rowsContainer) {
      rowsContainer.addEventListener('click', function (e) {
        var row = e.target.closest('.ts-v2-row');
        if (!row || row.classList.contains('ts-v2-row--sold-out')) return;

        var handle = row.dataset.handle;

        // Any row tap → swap gallery + auto-scroll on mobile
        if (handle === activeScent && !showingVideo) {
          // Re-tap same scent: deselect (back to no active state)
          activeScent = null;
          if (rowsContainer) {
            rowsContainer.querySelectorAll('.ts-v2-row').forEach(function (r) { r.classList.remove('ts-v2-row--active'); });
          }
          sectionEl.removeAttribute('data-active-scent');
        } else {
          setGallery(handle);
          // Auto-scroll gallery into view on mobile
          if (window.innerWidth <= 749 && galleryContainer) {
            galleryContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }

        // Check if a stepper button was clicked
        var btn = e.target.closest('[data-action]');
        if (btn) {
          var action = btn.dataset.action;
          if (action === 'plus') {
            // Membership: single-select — clear others
            if (currentPurchaseType === 'subscribe') {
              for (var h in quantities) {
                if (h !== handle) quantities[h] = 0;
              }
            }
            quantities[handle] = Math.min((quantities[handle] || 0) + 1, 10);
          } else if (action === 'minus') {
            quantities[handle] = Math.max(0, (quantities[handle] || 0) - 1);
          }
          updateAll();
        }
      });
    }

    // ── Package toggle (event delegation) ──
    var packageContainer = document.getElementById('showcase-package-' + sectionId);
    if (packageContainer) {
      packageContainer.addEventListener('click', function (e) {
        var pill = e.target.closest('[data-package]');
        if (!pill) return;
        currentPackage = pill.dataset.package || 'standard';
        // Patch 14 a11y: reflect selected state via aria-pressed + active class
        packageContainer.querySelectorAll('.topscent-showcase__swatch').forEach(function (p) {
          var on = (p === pill);
          p.classList.toggle('active', on);
          p.setAttribute('aria-pressed', on ? 'true' : 'false');
        });

        // Package-reactive gallery: swap to video
        if (currentPackage === 'gift') {
          setVideoGallery(PACKAGE_VIDEOS.gift);
          if (window.innerWidth <= 749 && galleryContainer) {
            galleryContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        } else if (currentPackage === 'standard') {
          setVideoGallery(PACKAGE_VIDEOS.standard);
          if (window.innerWidth <= 749 && galleryContainer) {
            galleryContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }

        updateAll();
      });
    }

    // ── Purchase-type selection (named so updateAll can force it) ──
    function selectPurchaseType(type) {
      currentPurchaseType = type || 'onetime';
      if (cardsGroup) {
        cardsGroup.querySelectorAll('.topscent-showcase__card').forEach(function (c) {
          var on = (c.dataset.purchase === currentPurchaseType);
          c.classList.toggle('active', on);
          c.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }
      // Membership: enforce single-select (keep the highest-qty scent only)
      if (currentPurchaseType === 'subscribe') {
        if (rowsContainer) rowsContainer.classList.add('ts-v2-rows--single');
        var maxH = null, maxQ = 0;
        for (var h in quantities) {
          if (quantities[h] > maxQ) { maxQ = quantities[h]; maxH = h; }
        }
        for (var h2 in quantities) {
          if (h2 !== maxH) quantities[h2] = 0;
        }
      } else {
        if (rowsContainer) rowsContainer.classList.remove('ts-v2-rows--single');
      }
      updateAll();
    }

    // ── Card toggle (event delegation) ──
    if (cardsGroup) {
      cardsGroup.addEventListener('click', function (e) {
        var card = e.target.closest('.topscent-showcase__card');
        if (!card) return;
        // Patch 14: ignore clicks on a disabled Membership card
        if (card.classList.contains('topscent-showcase__card--disabled')) return;
        selectPurchaseType(card.dataset.purchase || 'onetime');
      });
      // Patch 14 a11y: keyboard activation for the role=button cards
      cardsGroup.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
        var card = e.target.closest('.topscent-showcase__card');
        if (!card || card.classList.contains('topscent-showcase__card--disabled')) return;
        e.preventDefault();
        selectPurchaseType(card.dataset.purchase || 'onetime');
      });
    }

    // ── Cart submission ──
    if (atcBtn) {
      atcBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (atcBtn.disabled) return;

        var items = [];
        for (var h in quantities) {
          if (quantities[h] > 0) {
            var product = getProductByHandle(h);
            if (!product) continue;
            var variant = getActiveVariant(product);
            if (!variant) continue;
            var item = { id: variant.id, quantity: quantities[h] };
            if (currentPurchaseType === 'subscribe' && variant.selling_plans && variant.selling_plans[0]) {
              item.selling_plan = variant.selling_plans[0].id;
            }
            items.push(item);
          }
        }
        if (!items.length) return;

        atcBtn.disabled = true;
        atcBtn.textContent = 'Adding...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Cart error');
            return res.json();
          })
          .then(function () {
            atcBtn.textContent = 'Added \u2713';
            setTimeout(function () { window.location.href = '/cart'; }, 600);
          })
          .catch(function () {
            atcBtn.disabled = false;
            atcBtn.textContent = 'Something went wrong. Try again.';
            setTimeout(function () { updateAll(); }, 2000);
          });
      });
    }

    // ── Initial state ──
    updateAll();
  }

  // ── Boot: find all v2 sections on the page ──
  function bootAll() {
    document.querySelectorAll('.topscent-showcase[data-section-id]').forEach(initSection);
  }

  // ── Standard init ──
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  // ── Shopify Customize: re-init on section load/render ──
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.topscent-showcase[data-section-id]');
    if (section) initSection(section);
  });

})();
